import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderDataSchemaListComponent } from './data-schema-list.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';

@NgModule({
  declarations: [
    RappiderDataSchemaListComponent
  ],
  imports: [
    CommonModule,
    NzTreeModule
  ],
  exports: [
    RappiderDataSchemaListComponent
  ]
})
export class RappiderDataSchemaListModule { }
